import {autoserializeAs, autoserializeAsArray} from "dcerialize";
import type {IPaginated} from "../IPaginated";
import {NewsEntry} from "./NewsEntry";

export class News implements IPaginated<NewsEntry> {
  @autoserializeAsArray(() => NewsEntry)
  public readonly entries: readonly NewsEntry[];
  @autoserializeAs(() => Number)
  public readonly total: number;
}
